/**
 * @author bly
 * 功能：下架单
 */

import { Service } from '@/tools'

export class frameDownService<T extends TStock.frameDown> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.frameDown}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：分页查询下架单列表
   * /inner/stock/downRackForm/v1/queryStockDownRackFormPageList
   */
  pageList = <K extends T['ApiQueryStockDownRackFormPageList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQueryStockDownRackFormPageList', data)
  }

  /**
   * 模块说明： 查询下架单详情
   * /inner/stock/downRackForm/v1/queryStockDownRackFormDetal
   */
  detail = <K extends T['ApiQueryStockDownRackFormDetal']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQueryStockDownRackFormDetal', data)
  }

  /**
   * 模块说明： 整批下架
   * /inner/stock/downRackForm/v1/confirmBatchDownRack
   */
  confirmBatchDownRack = <K extends T['ApiConfirmBatchDownRack']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiConfirmBatchDownRack', data)
  }

  /**
   * 模块说明： 根据商品信息推荐架位
   * /inner/stock/downRackForm/v1/recommandDownRackBySku
   */
  recommandDownRackBySku = <K extends T['ApiRecommandDownRackBySku']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiRecommandDownRackBySku', data)
  }
}
